module.exports = __webpack_public_path__ + "img/movie_label.3d1be985.svg";